import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=02529164&scoped=true"
import script from "./Title.vue?vue&type=script&lang=ts"
export * from "./Title.vue?vue&type=script&lang=ts"
import style0 from "./Title.vue?vue&type=style&index=0&id=02529164&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02529164",
  null
  
)

export default component.exports